import { metricsBus } from "buses";
import amplitudeAnalytics from "services/amplitude/amplitudeAnalytics";

const isWatchPage = () => window.location.pathname.indexOf("/watch/") === 0;

const isFullscreen = () => {
  return !!document.querySelector("#root")?.classList?.contains("fullScreen");
};

metricsBus.on("forceFullscreenEntered", amplitudeAnalytics.sendForcedFullscreenEntered);

metricsBus.on("forceFullscreenExited", amplitudeAnalytics.sendForcedFullscreenExitClicked);

metricsBus.on("uploadStarted", amplitudeAnalytics.sendUploadStarted);

metricsBus.on("uploadTagSelectionStarted", amplitudeAnalytics.sendUploadTagSelectionStarted);

metricsBus.on("uploadTagSelectionEnded", ({ count }) => {
  amplitudeAnalytics.sendUploadTagSelectionEnded(count);
});

metricsBus.on("uploadEnded", amplitudeAnalytics.sendUploadEnded);

metricsBus.on("watchPageVisited", amplitudeAnalytics.sendWatchPageVisited);

metricsBus.on("gifView", ({ gifId }) => {
  if (isWatchPage()) {
    amplitudeAnalytics.sendWatchViewed(gifId, isFullscreen());
  }
});

metricsBus.on("meaningfulGifView", ({ gifId }) => {
  if (isWatchPage()) {
    amplitudeAnalytics.sendWatchViewedMeaningful(gifId, isFullscreen());
  }
});

metricsBus.on("gifLiked", ({ gifId }) => {
  if (isWatchPage()) {
    amplitudeAnalytics.sendWatchLiked(gifId, isFullscreen());
  }
});

metricsBus.on("gifUnliked", ({ gifId }) => {
  if (isWatchPage()) {
    amplitudeAnalytics.sendWatchUnliked(gifId, isFullscreen());
  }
});

metricsBus.on("addedToCollection", ({ gifId }) => {
  if (isWatchPage()) {
    amplitudeAnalytics.sendWatchAddedToCollection(gifId, isFullscreen());
  }
});

metricsBus.on("fullscreenEntered", () => {
  if (isWatchPage()) {
    amplitudeAnalytics.sendWatchFullscreenEntered();
  }
});

metricsBus.on("fullscreenExited", () => {
  if (isWatchPage()) {
    amplitudeAnalytics.sendWatchFullscreenExited();
  }
});

